export default "__VITE_ASSET__BNSW$E21__"